import {AbstractControl, ValidatorFn} from '@angular/forms';

import {SwiftValidatorKey} from './custom-validator-keys';

export function SwiftValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value && control.value.toString().trim();

        if (!controlValue) {
            return null;
        }

        return !/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(controlValue) ? {[SwiftValidatorKey]: true} : null;
    };
}
